export const COLLEGE_LIST_REQUEST = 'COLLEGE_LIST_REQUEST'
export const COLLEGE_LIST_SUCCESS = 'COLLEGE_LIST_SUCCESS'
export const COLLEGE_LIST_FAIL = 'COLLEGE_LIST_FAIL'
export const COLLEGE_LIST_RESET = 'COLLEGE_LIST_RESET'

export const COLLEGE_LIST_TOTAL_REQUEST = 'COLLEGE_LIST_TOTAL_REQUEST'
export const COLLEGE_LIST_TOTAL_SUCCESS = 'COLLEGE_LIST_TOTAL_SUCCESS'
export const COLLEGE_LIST_TOTAL_FAIL = 'COLLEGE_LIST_TOTAL_FAIL'
export const COLLEGE_LIST_TOTAL_RESET = 'COLLEGE_LIST_TOTAL_RESET'

export const COLLEGE_CREATE_REQUEST = 'COLLEGE_CREATE_REQUEST'
export const COLLEGE_CREATE_SUCCESS = 'COLLEGE_CREATE_SUCCESS'
export const COLLEGE_CREATE_FAIL = 'COLLEGE_CREATE_FAIL'
export const COLLEGE_CREATE_RESET = 'COLLEGE_CREATE_RESET'

export const COLLEGE_GET_REQUEST = 'COLLEGE_GET_REQUEST'
export const COLLEGE_GET_SUCCESS = 'COLLEGE_GET_SUCCESS'
export const COLLEGE_GET_FAIL = 'COLLEGE_GET_FAIL'
export const COLLEGE_GET_RESET = 'COLLEGE_GET_RESET'

export const COLLEGE_UPDATE_REQUEST = 'COLLEGE_UPDATE_REQUEST'
export const COLLEGE_UPDATE_SUCCESS = 'COLLEGE_UPDATE_SUCCESS'
export const COLLEGE_UPDATE_FAIL = 'COLLEGE_UPDATE_FAIL'
export const COLLEGE_UPDATE_RESET = 'COLLEGE_UPDATE_RESET'

export const COLLEGE_DELETE_REQUEST = 'COLLEGE_DELETE_REQUEST'
export const COLLEGE_DELETE_SUCCESS = 'COLLEGE_DELETE_SUCCESS'
export const COLLEGE_DELETE_FAIL = 'COLLEGE_DELETE_FAIL'

